module.exports = __webpack_public_path__ + "img/yuqingjiance.f49eca19.png";